import React from "react";
import PropertyCard from "./PropertyCard";

function SkeletonCard() {
  return (
    <div className="listing-card listing-card--skeleton" aria-hidden="true">
      <div className="listing-card__photo" />
      <div className="listing-card__body">
        <div className="listing-skeleton-line listing-skeleton-line--xs" />
        <div className="listing-skeleton-line listing-skeleton-line--lg" />
        <div className="listing-skeleton-line listing-skeleton-line--md" />
      </div>
    </div>
  );
}

function PropertyGrid({
  properties,
  loading,
  favorites,
  onToggleFavorite,
  onNavigate,
  hasActiveFilters,
  onClearFilters,
  emptyTitle,
  emptyDescription,
  emptyActions,
}) {
  const isFavorite = (property) =>
    favorites.some(
      (fav) => fav.imovelInfo?.codigo === property.imovelInfo?.codigo
    );

  if (loading) {
    return (
      <div className="listing-grid">
        {Array.from({ length: 8 }).map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    );
  }

  if (properties.length === 0) {
    return (
      <div className="listing-empty">
        <h3>{emptyTitle || "Nenhum imóvel encontrado"}</h3>
        <p>
          {emptyDescription ||
            (hasActiveFilters
              ? "Não encontramos imóveis com esses filtros. Tente alterar a cidade ou o bairro."
              : "No momento não há imóveis disponíveis nesta categoria.")}
        </p>
        {emptyActions ? (
          <div className="listing-empty__actions">{emptyActions}</div>
        ) : (
          hasActiveFilters &&
          onClearFilters && (
            <button type="button" onClick={onClearFilters}>
              Limpar filtros
            </button>
          )
        )}
      </div>
    );
  }

  return (
    <div className="listing-grid">
      {properties.map((property) => (
        <PropertyCard
          key={property.id}
          property={property}
          isFavorite={isFavorite(property)}
          onToggleFavorite={onToggleFavorite}
          onNavigate={onNavigate}
        />
      ))}
    </div>
  );
}

export default PropertyGrid;
